"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.SPACING = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

// Currency values
var SPACING = [0, 1, 2, 3, '3-half', 4, 5];
exports.SPACING = SPACING;
var propTypes = {
  children: _propTypes.default.node,

  /**
   *  Vertical spacing based on the Currency spacing system (1-5).
   */
  spacing: _propTypes.default.shape({
    top: _propTypes.default.oneOf(SPACING),
    bottom: _propTypes.default.oneOf(SPACING)
  })
};
exports.propTypes = propTypes;
var defaultProps = {
  spacing: {
    top: 0,
    bottom: 0
  }
};
exports.defaultProps = defaultProps;